import {
  firstNameField,
  lastNameField,
  birthdateField,
  GenderEnum,
  nullableInput,
} from "toptaal-shared"
import { z } from "zod"

export const onboardingStudentPersonalInfoSchema = z.object({
  firstName: firstNameField,
  lastName: lastNameField,
  birthDate: birthdateField,
  gender: nullableInput(GenderEnum),
})

export type OnboardingStudentPersonalInfoInput = z.input<
  typeof onboardingStudentPersonalInfoSchema
>

export type OnboardingStudentPersonalInfoOutput = z.infer<
  typeof onboardingStudentPersonalInfoSchema
>
